import { render, staticRenderFns } from "./ListMenuDivider.vue?vue&type=template&id=5ccec96c"
import script from "./ListMenuDivider.vue?vue&type=script&lang=js"
export * from "./ListMenuDivider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports